import { SmartTenantLogin } from '@/components/SmartTenantLogin';

/**
 * Interactive login entry. Sign-in redirects to the ABP login page via
 * `/connect/authorize`; the return trip is handled by the `/auth/callback` route, so
 * there is no in-page success handler here.
 */
export function Login() {
  return <SmartTenantLogin />;
}
